/**
 * Created by Carsten Bühler
 * User: c.buehler on 10.03.2017
 * Copyright: xdot GmbH 2015
 */


export function isOrganizationAdmin(roles) {
    for (let roleIdx in roles) {

        switch (roles[ roleIdx ].name) {
            case 'Administrator':
                return true;
            case 'Organization Owner':
                return true;
            case 'Organization Administrator':
                return true;
        }
    }
    return false;
}



// WEBPACK FOOTER //
// ./js/utils/role-util.js